import tw from 'tailwind-styled-components'

const InputRadio = tw.input`
h-[16px]
w-[16px] 
border-gray-300 
text-yellow 
focus:ring-0 
focus:ring-offset-0
`
const LabelRadio = tw.label`
ml-2
block 
text-[14px] 
font-normal 
text-darkGray
`
const Subtitle = tw.p`
mb-8
text-sm
text-darkGray/60
`

export { InputRadio, LabelRadio, Subtitle }
